const normalizeLdap = (value?: string | null): string | null => {
  const normalized = value?.trim().toLowerCase();
  return normalized ? normalized : null;
};

export const isSameLdap = (a?: string | null, b?: string | null): boolean => {
  const normalizedA = normalizeLdap(a);
  const normalizedB = normalizeLdap(b);
  return normalizedA != null && normalizedB != null && normalizedA === normalizedB;
};
